import { IconButton, styled } from '../../../../../../base-components';

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
    marginInlineStart: theme.spacing(2),
    '.MuiTouchRipple-root': {
        borderRadius: '50%',
    },
    width: 32,
    height: 32,
}));
